
import SvgIcon from "Theme/SvgIcon"
import { ReactComponent as NotificationIcon } from "../fontello/icons/svg/ic_notification.svg"


const Notification = ({ ...props }) => (
  <SvgIcon
    component={NotificationIcon}
    viewBox="0 0 1000 1000"
    {...props}
  />
)


export default Notification
